import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  return (
    <section
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div></div>
      <h1
        className="mb-4"
        style={{ fontSize: "2rem", fontWeight: 400 }}
      >Página no encontrada.</h1>
      <p className="mb-2" style={{ fontSize: "1.3rem" }}>
        Parece que la página a la que intentaste acceder no existe.
      </p>
      <span className="mt-3" style={{ fontSize: "1.3rem" }}>
        Regresa a la{" "}
        <Link to="/" className="link-underline">
          página de inicio.
        </Link>
      </span>
    </section>
  );
};

export default NotFound;